import request from '@/utils/request'
export function getListByPage(data) { // 新闻列表
    return request({
      url: `/api/Portal/New/GetListByPage`,
      method: 'post',
      data
    })
}
export function getPvNumber(data) { // 新闻列表
  return request({
    url: `/api/Portal/New/PV`,
    method: 'post',
    data
  })
}
export function GetInfoPN(data) { // 新闻 详情上下篇
  return request({
    url: `/api/Portal/New/GetInfoPN`,
    method: 'post',
    data
  })
}
